import { Component, Mixins, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
@Component
class MyQuestionMixin extends Mixins() {
  @Getter('user/userInfo') public userInfo: any
  // private questionId: any = this.$route.query.questionId;
  private userCreateQuestionList: any = [
    // 不同等级可新建问卷数
    { memberLevel: 1, maxNumber: 20, name: '免费版', subjectCount: 200 },
    { memberLevel: 2, maxNumber: 50, name: '专业版', subjectCount: 400 },
    { memberLevel: 3, maxNumber: 80, name: '专业增强版', subjectCount: 600 },
    { memberLevel: 4, maxNumber: 100, name: '企业版', subjectCount: 800 },
  ]
  // private copyTaskId:any=this.$route.query.taskId
  // 用户可创建信息
  get memberInfo() {
    // console.log(this.userCreateQuestionList,this.userInfo )
    return this.userCreateQuestionList.filter(
      (el: any) => el.memberLevel === this.userInfo.memberLevel
    )[0]
  }

  // 是否超过题目数 0:超过  1：不超过
  get isOverSubject() {
    return async (questionId: any) => {
      const data = await this.$apis.getSubjectCount({ questionId })
      // console.log(data, this.memberInfo.subjectCount, data.subjectCount >= this.memberInfo.subjectCount)
      if (data.subjectCount > this.memberInfo.subjectCount) {
        // this.overflowSubjectDialog()
        return 0
      } else {
        return 1
      }
    }
  }

  // 复制问卷
  public mixin_copyNewQuestion({
    questionId,
    taskId,
    taskType,
    dailyTaskType,
  }: any) {
    return new Promise(async (resolve: any, reject: any) => {
      // const res: any = await this.$apis.getQuestionCopy({ questionId,taskId:  })
      // console.log(encodeURIComponent(this.$tool.encrypt(116)) )
      const questionCount = await this.getQuestionCount() // 0：超过  1：不超过
      const subjectCount = await this.isOverSubject(questionId) // 是否超过题目数 0:超过  1：不超过
      console.log(questionCount, this.memberInfo.maxNumber, subjectCount)
      if (questionCount === 1 && subjectCount === 1) {
        const ids: any = `${taskType}-${dailyTaskType}`
        const res: any = await this.$apis.getQuestionCopy({
          questionId,
          taskId: ['2-8'].includes(ids)
            ? this.$tool.encrypt(taskId)
            : undefined,
        })

        if (res) {
          if (res.isCreate === 1) {
            if (taskId && ['2-6'].includes(ids)) {
              // 引用一个模板创建问卷
              this.$apis.completeTask({
                taskId: this.$tool.encrypt(taskId),
                isComplete: 1,
              })
            } else if (taskId && ['2-2', '2-3'].includes(ids)) {
              // 创建项目并收集至少10份问卷
              this.$apis.saveTaskQuestion({
                taskId: this.$tool.encrypt(taskId),
                questionId: res.questionId,
              })
            }
            resolve(res)
          } else if (res.isCreate === 0) {
            // 超过问卷创建数
            this.overflowQuestionDialog()
            reject()
          } else if (res.isCreate === 2) {
            // 超过题目数
            this.overflowSubjectDialog()
            reject()
          }
        }
      } else if (subjectCount === 0) {
        this.overflowSubjectDialog()
        reject()
      } else {
        this.overflowQuestionDialog()
        reject()
      }
    })
  }
  // 新建问卷  paramsData {questionType,taskId,dailyTaskType}
  /**
   * @param   questionType 问卷类型
   * @param   taskId  // 任务id
   * @param   taskType  // 任务类型
   * @param   dailyTaskType   // 每日任务类型
   */
  public async mixin_createNewQuestion({
    questionType,
    taskId,
    taskType,
    dailyTaskType,
    solitaireType,
  }: any) {
    let parmas = {}
    const questionCount = await this.getQuestionCount() // 0：超过  1：不超过

    // const memberInfo: any = this.userCreateQuestionList.filter((el: any) => el.memberLevel === this.userInfo.memberLevel)[0]   // 用户可创建次数
    switch (questionType) {
      case 'questionnaireAppoint':
        parmas = {
          questionType: 7,
          title: '在线预约标题',
          subtitle: '请选择你所需要预约的信息，我们将在第一时间为你安排。',
          conclusion: '您已完成本次预约，感谢您的帮助与支持',
          shareTitle: '在线预约',
        }
        break
      case 'questionnaireOnline':
        parmas = {
          questionType: 6,
          title: '在线收款标题',
          subtitle: '',
          conclusion: '',
          shareTitle: '在线收款',
        }
        break
      case 'questionnaireSolitaire':
        parmas = {
          questionType: 5,
          title: '接龙标题',
          subtitle:
            '感谢您能抽出几分钟时间来参加本次接龙，现在我们就马上开始吧！',
          conclusion: '接龙成功，谢谢您的参与！',
          solitaireType,
          shareTitle: '在线接龙',
        }
        break
      case 'questionnaireForm':
        parmas = {
          questionType: 4,
          title: '报名表单标题',
          subtitle:
            '感谢您能抽出几分钟时间来参加本次报名表单，现在我们就马上开始吧！',
          conclusion: '表单已提交成功，谢谢您的参与！',
          shareTitle: '报名表单',
        }
        break

      case 'questionnaireExam':
        parmas = {
          questionType: 2,
          title: '考试测评标题',
          subtitle: '欢迎参加本次考试测评，准备好了吗？我们现在开始吧！',
          shareTitle: '考试测评',
        }
        break

      default:
        parmas = {
          questionType: 1,
          title: '问卷调研标题',
          subtitle:
            '为了给您提供更好的服务，希望您能抽出几分钟时间，将您的感受和建议告诉我们，我们非常重视每位用户的宝贵意见，期待您的参与！现在我们就马上开始吧！',
          conclusion: '您已完成本次问卷，感谢您的参与！',
          shareTitle: '问卷调研',
        }
        break
    }
    if (questionCount === 1) {
      const questionData = await this.$apis.saveOrUpdateWxQuestion(parmas)
      if (questionData.questionId && questionData.isCreate !== 0) {
        const ids: any = `${taskType}-${dailyTaskType}`

        if (taskId && ['2-2', '2-3'].includes(ids)) {
          // 创建一份问卷（题目数≥5） | 创建项目并收集至少10份问卷
          this.$apis.saveTaskQuestion({
            taskId: this.$tool.encrypt(taskId),
            questionId: questionData.questionId,
          })
        }
        this.$router.push({
          name: 'questionnaireAdd',
          query: { questionId: this.$tool.encrypt(questionData.questionId) },
        })
      } else if (questionData.isCreate === 0) {
        this.overflowQuestionDialog()
      }
    } else {
      this.overflowQuestionDialog()
    }
  }

  // 超过次数弹窗
  public overflowQuestionDialog() {
    this.$InfoDialog({
      content: `${this.memberInfo.name}每天支持创建${this.memberInfo.maxNumber}个项目，请升级版本`,
      title: '提示',
      width: '486px',
      isCenter: true,
      cancelBtn: false,
      confirmBtnText: '升级版本',
    }).then(() => {
      this.toMemberOpen()
    })
  }
  // 超过题目数次数弹窗
  public overflowSubjectDialog() {
    this.$InfoDialog({
      content: `抱歉！该版本不支持更多题目，请升级！`,
      title: '提示',
      width: '486px',
      isCenter: true,
      cancelBtn: false,
      confirmBtnText: '升级版本',
    }).then(() => {
      this.toMemberOpen()
    })
  }
  // 是否超过问卷数量  0：超过  1：不超过
  private async getQuestionCount() {
    const data = await this.$apis.getQuestionCount({})

    if (data.questionCount >= this.memberInfo.maxNumber) {
      return 0
    } else {
      return 1
    }
  }

  private toMemberOpen() {
    window.open(
      `/member/index.html?isOpen=${this.userInfo.memberLevel}`,
      '_blank'
    )
  }
}
export default MyQuestionMixin
